import React from 'react'
import ComplexNavbar from '../navbar/Navbar'
import Footer from '../Footer/footer'
import ContactForm from '../Form/Contact/Contact'
import Banner from '../Banner/Banner'
export default function Contact() {
  return (
    <div>
        
        <ComplexNavbar/>   
<Banner />
        
         
<ContactForm />

<br />
    
<Footer/>

    
    </div>
  )
}
